import { render, staticRenderFns } from "./MensagemUpgrade.vue?vue&type=template&id=43e3caad&scoped=true&"
import script from "./MensagemUpgrade.vue?vue&type=script&lang=js&"
export * from "./MensagemUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./MensagemUpgrade.vue?vue&type=style&index=0&id=43e3caad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e3caad",
  null
  
)

export default component.exports